export const incidentsTypes = {
  GET_SERVICES: 'GET_SERVICES',
  GET_CATEGORIES: 'GET_CATEGORIES',
  GET_SUBCATEGORIES: 'GET_SUBCATEGORIES',
}
